import { SvgIcon, SvgIconProps } from '@material-ui/core'

export default function OptionsEllipsesIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
            <g>
                <circle cx="12" cy="6" r="2" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
                <circle cx="12" cy="12" r="2" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
                <circle cx="12" cy="18" r="2" fillRule="evenodd" clipRule="evenodd" fill="currentColor" />
            </g>
        </SvgIcon>
    )
}
